import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { TPVServices } from "../../../services";
import { Globals } from "../../../../../globals";
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the TpvTicketSelectedPayPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-tpv-ticket-select-element',
  templateUrl: 'tpv-ticket-select-element.html',
})
export class TpvTicketSelectElementPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public tpvServices: TPVServices,
    public globals: Globals,
    private toastCtrl: ToastController,
    public translate: TranslateService) {

  }

  insertElement(element) {
    if (this.tpvServices.keyboard_screen) {
      //split 2 get quantity
      var splitted = this.tpvServices.keyboard_screen.split("x");
      this.tpvServices.keyboard_screen = splitted[0];

      if (!Number.isNaN(parseFloat(this.tpvServices.keyboard_screen))) {
        this.tpvServices.insertTable(element + '-' + this.tpvServices.keyboard_screen, parseFloat(this.tpvServices.keyboard_screen), false, true, 'other', '', {});
        this.tpvServices.deleteKeyboard();
        this.navCtrl.pop();
      } else {
        this.navCtrl.pop();
      }

    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-selecciona-cantidad-elemento'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }


  }

  onBack() {
    this.tpvServices.deleteKeyboard();
    this.navCtrl.pop();
  }





}



// WEBPACK FOOTER //
// ./src/pages/tpv/tpv-ticket/tpv-ticket-selected/tpv-ticket-select-element/tpv-ticket-select-element.ts